"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.turkish = void 0;
var types_1 = require("../types");
exports.turkish = {
    code: types_1.LocaleCode.Turkish,
    facebook: 'tr_TR',
    label: 'Türkçe',
    loadingText: 'Yükleniyor...',
    translations: {
        ar: 'Arapça',
        de: 'Almanca',
        en: 'ingilizce',
        es: 'İspanyol',
        fr: 'Fransızca',
        id: 'Endonezya dili',
        it: 'İtalyan',
        ja: 'Japonca',
        ko: 'Koreli',
        lo: 'Laoca',
        ms: 'Malay',
        pt: 'Portekizce',
        ru: 'Rusça',
        th: 'Tay dili',
        tl: 'Filipinli',
        tr: 'Türkçe',
        vi: 'vietnam',
        'zh-CN': 'Basitleştirilmiş Çince',
        'zh-TW': 'Çin geleneği'
    }
};
